import { useState } from "react";

// Ticking tasks off a list (Goals, Tasks, Radar, Key Dates): a ticked row greys while it saves, and a failed save
// un-greys it (DoneCheck says it failed). A saved one is let go too: by then it has left the list, and a Key Date card
// can untick it, which must bring it back as a task to do. onDone(task) saves and returns a promise. Returns { isTicked(id), tick(task) }.
export function useTickTasks(onDone) {
  const [ticked, setTicked] = useState(() => new Set());
  const untick = (id) => setTicked(s => { const n = new Set(s); n.delete(id); return n; });
  const tick = (task) => {
    setTicked(s => new Set([...s, task.id]));
    return onDone(task).then(() => untick(task.id), e => { untick(task.id); throw e; });
  };
  return { isTicked: (id) => ticked.has(id), tick };
}
